import { render } from "./getTask.vue?vue&type=template&id=1c0b424a&scoped=true"
import script from "./getTask.vue?vue&type=script&lang=js"
export * from "./getTask.vue?vue&type=script&lang=js"

import "./getTask.vue?vue&type=style&index=0&id=1c0b424a&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c0b424a"]])

export default __exports__